module.exports = __webpack_public_path__ + "img/venta_3.7b694aed.svg";